module.exports = __webpack_public_path__ + "img/redzonemanhole.81dabcab.png";